/**
 * Aufnahmen und Live-Mithoeren.
 * Grundlage: 07_recording_monitoring.md, 10_main_admin.md
 */

/**
 * Zeitraumfilter fuer den kampagnenweisen Aufnahme-Download.
 *
 * Bewusst nur diese vier Werte - der Systemadmin soll Aufnahmen holen, nicht
 * nach ihnen suchen.
 */
export const RECORDING_PERIOD = {
  TODAY: 'today',
  WEEK: 'week',
  MONTH: 'month',
  ALL: 'all',
} as const;

export type RecordingPeriod = (typeof RECORDING_PERIOD)[keyof typeof RECORDING_PERIOD];

export const RECORDING_PERIOD_VALUES = Object.values(RECORDING_PERIOD);

export function isRecordingPeriod(value: unknown): value is RecordingPeriod {
  return typeof value === 'string' && (RECORDING_PERIOD_VALUES as string[]).includes(value);
}

/**
 * Aufbewahrung (07_recording_monitoring.md).
 *
 * Der Kundenadmin kommt sieben Tage an eine Aufnahme, der Systemadmin
 * dreissig. Danach wird die Datei endgueltig geloescht; das Gespraechsprotokoll
 * bleibt bestehen.
 */
export const RECORDING_TENANT_RETENTION_DAYS = 7;
export const RECORDING_PLATFORM_RETENTION_DAYS = 30;

/**
 * Wer darf mithoeren?
 *
 * Beide duerfen ausschliesslich zuhoeren - kein Sprechen, kein Whisper, kein
 * Barge-In. Der Unterschied liegt nur im Umfang: der Kundenadmin bei seinen
 * eigenen Callern, der Systemadmin bei allen Mandanten.
 */
export const LISTENER_SCOPE = {
  /** Kundenadmin - ausschliesslich eigener Mandant. */
  TENANT: 'tenant',
  /** Systemadmin - alle Mandanten. */
  PLATFORM: 'platform',
} as const;

export type ListenerScope = (typeof LISTENER_SCOPE)[keyof typeof LISTENER_SCOPE];
